var exports = {
  "K": "peopleGrid__hY4_TW",
};

module.exports = exports;
